<!--
/**
* @name: MoreTabItem.vue
* @description: 更多菜单模板
* @author: 温永江
* @create: 2020/07/22 15:58:40
* @update: 2020/07/22 15:58:40
*/
-->

<template>
  <k-dropdown :class="[css.kd, { [css.active]: show }]"
    :show.sync="visible"
    gap="0"
    trigger="hover"
    alignment="left"
    :bodyClassName="css.body"
    :title="rTitle()"
    :white-list="wh"
    :body="rBody()"></k-dropdown>
</template>
<script>
// import Ctx from './ContextMenu';

export default {
  components: {
    // Ctx,
  },
  props: {
    show: Boolean,
    data: {
      type: Array,
      default: () => []
    }
  },
  model: {
    prop: 'show',
    event: 'showChange'
  },
  data() {
    return {
      visible: this.show,
      showCtx: false,
      top: -9999,
      left: -9999,
      currentSubMenu: {},
      currentCtxMenu: {},
      wh: []
    };
  },
  computed: {
    c_data() {
      // 每15个一组,分成一个二维数组
      let arr2 = [];
      let i = 0;
      let len = this.data.length;
      let br = false;
      while (true) {
        let arr = [];
        let j = 0;
        while (j < 15) {
          if (this.data[i * 15 + j]) {
            arr.push(this.data[i * 15 + j]);
          } else {
            br = true;
            break;
          }
          j++;
        }
        arr2.push(arr);
        if (br) {
          break;
        }
        i++;
      }
      return arr2;
    }
  },
  methods: {
    rTitle() {
      return <div class={{ [this.css.tit]: true }}>{this.data.length}</div>;
    },
    rItem(data) {
      return data.map((d) => {
        const { css } = this;
        const isCur = this.currentSubMenu.id == d.id;
        return (
          <div
            class={[css.item, { [css.cur]: isCur }]}
            onClick={(e) => {
              this.$emit('go', d);
              // this.visible = false;
            }}
          >
            <div>
              <k-icon
                name="k-icon-arrow-right-solid"
                class={[
                  css.ok,
                  {
                    [css.show]: isCur
                  }
                ]}
              />
              <span >{d.name}</span>
            </div>
            <k-icon
              name="k-icon-close"
              class={css.close}
              onClick={(e) => {
                this.$emit('close', d);
                e.stopPropagation();
              }}
            />
          </div>
        );
      });
    },
    rCtx() {
      const p = {
        ref: 'ctx',
        props: {
          show: this.showCtx,
          top: this.top,
          left: this.left
        },
        on: {
          showChange: (v) => {
            this.showCtx = v;
          },
          close: (i) => {
            this.visible = false;
            this.$emit('close-by-ctx', i);
          }
        }
      };
      return <Ctx {...p} />;
    },
    rBody() {
      const { css } = this;
      return this.c_data.map((data, i) => <div class={css.list}>
        {i == 0 ? <div class={{ 'row row-between': true, [css.all]: true }}>
          <span class="text-gray-3">标签页</span>
          <a href="javascript:;" class="link"
            onClick={() => {
              this.visible = false;
              this.$emit('close-by-ctx', 2);
            }}>关闭全部</a>
        </div> : null}
        {this.rItem(data)}
      </div >);
    }
  },
  watch: {
    visible(v) {
      this.$emit('showChange', v);
      if (v) {
        this.$lf.getItem('currentSubMenu').then((data) => {
          if (data) this.currentSubMenu = data;
        });
      }
    },
    show(v) {
      this.visible = v;
    }
  }
};
</script>
<style lang="postcss" module="css">
.kd {
  position: absolute;
  top: 7px;
  right: 0;
  cursor: pointer;
  transition: var(--transition);
  border: 1px solid #d9d9d9;
  border-radius: var(--radius);
  &:hover,
  &.active {
    background-color: white;
  }
}
.ib {
  display: inline-block;
}

.body {
  max-height: none;
  background-color: white;
  padding: 0;
  display: flex;
}
.list {
  padding: 10px 0;
  flex: none;
  &:not(:first-child) {
    border-left: 1px solid var(--color-border);
  }
}
.all {
  padding: 5px 12px;
}
.item {
  height: 32px;
  line-height: 32px;
  color: var(--color-font-2);
  padding: 0 10px 0 3px;
  cursor: pointer;
  transition: var(--transition);
  white-space: nowrap;
  display: flex;
  justify-content: space-between;
  margin: 0 0 0 12px;
  &.cur {
    background-color: var(--color-primary);
    color: white;
  }
  & .ok {
    font-size: 14px;
    color: var(--color-primary);
    visibility: hidden;
    margin-right: 5px;
    &.show {
      visibility: visible;
    }
  }
  & .close {
    visibility: hidden;
    margin-left: 15px;
    font-size: 13px;
    padding-right: 5px;
  }
  &:hover {
    &:not(.cur) {
      color: var(--color-primary);
    }
    & .close {
      visibility: visible;
    }
    & .ok {
      visibility: visible;
    }
    &.cur {
      & .ok {
        color: white;
      }
    }
  }
}
</style>
